import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const TargetPreciselyImage = () => {
  const data = useStaticQuery(graphql`
    query {
      TargetPreciselyImage: file(
        relativePath: { eq: "platform/automation/target-precisely.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.TargetPreciselyImage.childImageSharp.fluid}
      alt="Target Precisely Image"
    />
  )
}

export default TargetPreciselyImage
